import { render, staticRenderFns } from "./WalletCard.vue?vue&type=template&id=6abdc38c&scoped=true&"
import script from "./WalletCard.vue?vue&type=script&lang=js&"
export * from "./WalletCard.vue?vue&type=script&lang=js&"
import style0 from "./WalletCard.vue?vue&type=style&index=0&id=6abdc38c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../store-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abdc38c",
  null
  
)

export default component.exports